import { Component, computed, effect, inject, input, viewChild } from '@angular/core';
import { FullscreenLayout } from '../../../layout/components/fullscreen-layout/fullscreen-layout';
import { ParseRequestsStore } from '../../stores/parse-requests.store';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SimpleDialog } from 'excellence-ui';
import { ParseRequestCreateHeader } from '../../components/parse-request-create-header/parse-request-create-header';
import { ParseRequestCreateNav } from '../../components/parse-request-create-nav/parse-request-create-nav';
import { ParseRequestCreatedRequirementsDialog } from '../../dialogs/parse-request-created-requirements-dialog/parse-request-created-requirements-dialog';

@Component({
  selector: 'app-parse-request-create-page',
  imports: [
    FullscreenLayout,
    ErrorPage,
    RouterOutlet,
    ParseRequestCreateHeader,
    ParseRequestCreateNav,
    ParseRequestCreatedRequirementsDialog,
    SimpleDialog,
  ],
  templateUrl: './parse-request-create-page.html',
})
export class ParseRequestCreatePage {
  private parseRequestsStore = inject(ParseRequestsStore);
  protected router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  organizationId = input.required<string>();
  parseRequestId = input.required<string>();

  state = computed(() => {
    const id = this.parseRequestId();
    return this.parseRequestsStore.parseRequests()?.find((pr) => pr.id === id) ?? null;
  });
  private requirementsDialog = viewChild.required<SimpleDialog>('requirementsDialog');

  constructor() {
    effect(() => {
      if (this.activatedRoute.snapshot.queryParamMap.get('showDialog') === 'true') {
        this.requirementsDialog()?.showModal();
      }
    });
  }
}
